import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { rootReducer } from "./rootReducer";
  
// Редюсер прередается в стор
export const store = createStore(rootReducer, composeWithDevTools())